import { Alert, Button, Dialog, Text } from "@hcsc-fiber/react";
import React, { useContext, useState } from "react";
import { StateContext } from "../../context/stateContext";
import { translations } from "../../translate";
import PasswordInput from "../PasswordInput/PasswordInput";

declare type asyncSubmit = (_: string) => Promise<void>;
declare type submit = (_: string) => void;

interface DisconnectConsentDialogProps {
  isOpen: boolean;
  title: string;
  submitButtonTitle: string;
  error: { message: string; code: string } | null;
  onClose: () => void;
  onSubmit: asyncSubmit | submit;
  clearError: () => void;
  setDisconnectErrors: (_: { message: string; code: string } | null) => void;
}

const DisconnectConsentDialog: React.FC<DisconnectConsentDialogProps> = ({
  isOpen,
  onClose,
  onSubmit,
  clearError,
  submitButtonTitle,
  title,
  error,
  setDisconnectErrors,
}) => {
  const [password, setPassword] = useState("");
  const language = useContext(StateContext).languageCode;

  const handleSubmit = () => {
    onSubmit(password);
  };

  return (
    <Dialog onClose={onClose} isOpen={isOpen}>
      <Dialog.Title>{title}</Dialog.Title>
      <Dialog.Content>
        {error && (
          <Alert kind="danger" onDismiss={clearError}>
            {error.message}
          </Alert>
        )}
        <Text as="p" margin={[3, 0, 3]}>
          {translations.enterPassword[language]}
        </Text>
        <PasswordInput
          isInvalid={!!error?.message}
          value={password}
          onChange={({ target }) => {
            if (target.value.length === 0) {
              setDisconnectErrors(null);
            }
            setPassword(target.value);
          }}
          error={error}
          data-testid="revoke-password-input"
        />
        {error && (
          <span style={{ color: "#E10000", display: "inline-block", marginTop: "10px" }} data-testid="erro-message">
            Please re-enter your password
          </span>
        )}
      </Dialog.Content>
      <Dialog.Actions>
        <Button disabled={!password.length} kind="primary" onClick={handleSubmit} data-testid="disconnect-dialog-btn">
          {submitButtonTitle}
        </Button>
        <Button kind="tertiary" onClick={onClose}>
          {translations.cancel[language]}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default DisconnectConsentDialog;
